module.exports = __webpack_public_path__ + "static/media/illu-footer.e552b7a2.svg";